import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // localStorage
import componentsSlice from './components/components-slice'
import userSlice from './user/user-slice'
import companySlice from './company/reducer'
import employeeSlice from './employee/reducer'
import payrollSlice from './payroll/reducer'
import sectionSlice from './section/reducer'
import miscSlice from './miscellaneous/reducer'
import recruitmentSlice from './human-resources/reducers/recruitment'
import onboardingSlice from './onboarding/reducer'
import dashboardCardsSlice from './dashboard-card/dashboard-card-slice'

const reducer = combineReducers({
  // add all reducers here.
  componentsSlice,
  userSlice,
  companySlice,
  employeeSlice,
  payrollSlice,
  sectionSlice,
  onboardingSlice,
  recruitmentSlice,
  miscSlice,
  dashboardCardsSlice,
})

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['components', 'onboarding'],
}

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
  // Ensures Redux does not throw warnings about non-serializable actions related to redux-persist
  // actions (FLUSH, REHYDRATE, etc.) are necessary for redux-persist to work properly.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production' ? true : false,
})

export const persistor = persistStore(store)
